import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useQuery} from '@tanstack/react-query'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {getMrtApiBasepath} from '../ssr/helpers'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import fetch from 'cross-fetch'

const useGlobalCustomPreferencesListQuery = () => {
    const {getTokenWhenReady} = useAccessToken()
    const {locale} = useMultiSite()
    const origin = useAppOrigin()

    async function getGlobalCustomPreferencesList() {
        try {
            const token = await getTokenWhenReady()
            const endpoint = origin + getMrtApiBasepath('/global-custom-preferences-list')

            const options = {
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                method: 'GET',
                credentials: 'same-origin',
            }

            const response = await fetch(`${endpoint}`, options)
            const data = await response.json()
            //console.debug('Global Custom Preferences List:', data)

            return data
        } catch (e) {
            console.error('Error fetching custom preferences list:', e)
        }
    }

    return useQuery(['getGlobalCustomPreferencesList', locale.id], () =>
        getGlobalCustomPreferencesList(),
    )
}

export default useGlobalCustomPreferencesListQuery
